export default "__VITE_ASSET__BLdfkaDA__"